import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  root: {
    margin: '10px',
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: 'rgb(2, 123, 253)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'yellow',
    },
  },
  dialogContent: {
    marginTop: '32px',
  },
  requestAccessMessage: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '-20px',
  },
  requestAccessSelectionHeader: {
    fontSize: '0.875rem',
  },
  accessTypeDesc: {
    margin: '-10px 0px 30px 32px',
    fontSize: '0.75rem',
    color: '#617080',
  },
  dialogInputField: {
    marginBottom: '30px',
  },
  requestMessage: {
    fontSize: '1rem !important',
    fonntWeight: 'bold',
    marginBottom: '0px',
  },
  messageText: {
    fontFamily: 'inherit',
    width: '500px',
    minHeight: '80px',
    margin: '0px',
    padding: '4px',
    resize: 'none',
    color: '#617080',
    border: 'solid 1px #617080',
    borderRadius: '4px',
  },
  smallRadioButton: {
    '& svg': {
      width: '1.5rem',
      height: '1.5rem',
    },
  },
}));
